import { FC, MouseEvent } from 'react';
import { Tooltip } from 'antd';
import { AiIconName } from '../../Utils/icons';
import { AiIcon } from '../AiIcon';
import { IconButtonBase } from './styles';

export interface IconButtonProps {
  icon: AiIconName;
  label: string;
  onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
  active?: boolean;
  disabled?: boolean;
  tooltip?: boolean;
}

/** "Chat AI / Header / Button" do Figma: botão de ícone 16px com padding 4px. */
export const IconButton: FC<IconButtonProps> = ({
  icon,
  label,
  onClick,
  active,
  disabled,
  tooltip = true
}) => {
  const button = (
    <IconButtonBase
      type="button"
      aria-label={label}
      aria-pressed={active}
      $active={active}
      disabled={disabled}
      onClick={onClick}
    >
      <AiIcon name={icon} />
    </IconButtonBase>
  );

  if (!tooltip) {
    return button;
  }

  return (
    <Tooltip title={label} placement="bottom" mouseEnterDelay={0.4}>
      {button}
    </Tooltip>
  );
};
